import React, { useState } from 'react';
import { CSVLink } from "react-csv";

const TablaStudentRegister = ({ students, selectedEditStudent, edit }) => {

  const [search, setSearch] = useState("");

  const headers_csv = [
    {key: "name", label: "Nombre" },
    {key: "curp", label: "CURP" },
    {key: "career", label: "Carrera" },
    {key: "date_init", label: "Fecha Ingreso" },
    {key: "generation_code", label: "Gen" },
    {key: "mode", label: "Modalidad" },
    {key: "date_generation_init", label: "Inicio" },
    {key: "date_generation_end", label: "Termino" },
    {key: "status", label: "Estado" },
  ];

  // Filtrado por nombre o curp
  const filteredStudents = students.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.curp.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="flex justify-between items-center py-5">
        <h4 className="text-lg font-semibold">Alumnos Registrados</h4>

        <div className="flex gap-3 items-center">
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '260px' }}>
            <span style={{ position: 'absolute', left: '10px', color: '#9ca3af', pointerEvents: 'none', display: 'flex', alignItems: 'center' }}>
              <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '12px' }}></i>
            </span>
            <input
              type="text"
              placeholder="Buscar por nombre o CURP..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: '100%', paddingLeft: '32px', paddingRight: '12px',
                paddingTop: '7px', paddingBottom: '7px',
                border: '1px solid #d1d5db', borderRadius: '7px', fontSize: '0.82rem',
                backgroundColor: '#fff', outline: 'none',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                transition: 'border-color 0.15s, box-shadow 0.15s',
              }}
              onFocus={(e) => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 3px rgba(220,38,38,0.1)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#d1d5db'; e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.04)'; }}
            />
          </div>

          {/* CSV */}
          <CSVLink data={students} headers={headers_csv} filename={"Alumnos.csv"}>
            <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
              Descargar Lista
            </button>
          </CSVLink>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border text-xs">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-4 border text-left">Nombre</th>
              <th className="py-2 px-4 border text-left">CURP</th>
              <th className="py-2 px-4 border text-left">Carrera</th>
              <th className="py-2 px-4 border text-left">Fecha Ingreso</th>
              <th className="py-2 px-4 border text-left">Gen.</th>
              <th className="py-2 px-4 border text-left">Modalidad</th>
              <th className="py-2 px-4 border text-left">Inicio</th>
              <th className="py-2 px-4 border text-left">Termino</th>
              <th className="py-2 px-4 border text-left">Estado</th>
              {edit && <th className="py-2 px-4 border text-left">Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {filteredStudents.map(student => (
              <tr key={student.id}>
                <td className="py-2 px-4 border">{student.name}</td>
                <td className="py-2 px-4 border">{student.curp}</td>
                <td className="py-2 px-4 border">{student.career}</td>
                <td className="py-2 px-4 border">{student.date_init}</td>
                <td className="py-2 px-4 border">{student.generation_code}</td>
                <td className="py-2 px-4 border">{student.mode}</td>
                <td className="py-2 px-4 border">{student.date_generation_init}</td>
                <td className="py-2 px-4 border">{student.date_generation_end}</td>
                <td className="py-2 px-4 border">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      student.status === 'Activo'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}>
                    {student.status}
                  </span>
                </td>

                {edit && (
                  <td className="py-2 px-4 border">
                    <button
                      className="px-3 py-1 bg-yellow-600 text-white rounded hover:bg-yellow-700 text-sm"
                      onClick={() => selectedEditStudent(student)}
                    >
                      Editar
                    </button>
                  </td>
                )}
              </tr>
            ))}

            {filteredStudents.length === 0 && (
              <tr>
                <td colSpan={edit ? 10 : 9} className="text-center py-4">
                  No se encontraron resultados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TablaStudentRegister;
